import { PropsWithChildren } from 'react';

import { cn } from '@/lib/utils';

import { PricingSectionCardCellProps } from './PricingSectionPriceCardCell';

const cellBgMap = {
  header: {
    regular: 'bg-gray-200',
    withBadgeOfHonor: 'bg-brand-950'
  },
  row: {
    regular: 'bg-gray-100',
    withBadgeOfHonor: 'bg-brand-975'
  }
};

const getBgClassName = (props: PricingSectionCardCellProps) => {
  const { isHeaderCell, hasBadgeOfHonor } = props;

  return cellBgMap[isHeaderCell ? 'header' : 'row'][
    hasBadgeOfHonor ? 'withBadgeOfHonor' : 'regular'
  ];
};

const PricingSectionCardCell = ({
  children,
  isHeaderCell,
  hasBadgeOfHonor,
  classNames
}: PropsWithChildren<PricingSectionCardCellProps> & {
  classNames?: { wrapper?: string };
}) => {
  return (
    <div
      className={cn(
        'relative w-full text-center overflow-hidden flex items-center justify-center p-4',
        isHeaderCell ? 'h-20' : 'h-14',
        getBgClassName({ isHeaderCell, hasBadgeOfHonor }),
        classNames?.wrapper
      )}
    >
      {children}
    </div>
  );
};

export default PricingSectionCardCell;
